<template>
  <div class="marketing-automation-form-panel"
       :class="{ 'marketing-automation-form-panel_hidden': !showing, 'marketing-automation-form-panel_opened' : isFilterOpened}">
    <div class="marketing-automation-form-panel-header border-bottom">
      <div class="close"
           @click="hidePanel">&times;</div>
      <h5 class="marketing-automation-form-panel-header-title text-center">{{ title }}</h5>
    </div>

    <marketing-automation-form-panel-entry v-if="isEntryType"
                                           :step="step"
                                           :automationId="automationId"
                                           @opened="setIsFilterOpened(true)"
                                           @hidden="setIsFilterOpened(false)"
                                           @submit="emitSteps" />

    <marketing-automation-form-panel-email v-if="isEmailType"
                                           :step="step"
                                           :automationId="automationId"
                                           @submit="emitSteps" />

    <marketing-automation-form-panel-sms v-if="isSmsType"
                                         :step="step"
                                         :automationId="automationId"
                                         @submit="emitSteps" />

    <marketing-automation-form-panel-whatsapp v-if="isWhatsappType"
                                              :step="step"
                                              :automationId="automationId"
                                              @submit="emitSteps" />

    <marketing-automation-form-panel-timer v-if="isTimerType"
                                           :step="step"
                                           :automationId="automationId"
                                           @submit="emitSteps" />
  </div>
</template>

<script>
import MarketingAutomationFormPanelEmail from "@components/modules/marketing/automation/form/steps/panel/email/MarketingAutomationFormPanelEmail";
import MarketingAutomationFormPanelEntry from "@components/modules/marketing/automation/form/steps/panel/entry/MarketingAutomationFormPanelEntry";
import MarketingAutomationFormPanelSms from "@components/modules/marketing/automation/form/steps/panel/sms/MarketingAutomationFormPanelSms";
import MarketingAutomationFormPanelTimer from "@components/modules/marketing/automation/form/steps/panel/timer/MarketingAutomationFormPanelTimer";
import MarketingAutomationFormPanelWhatsapp from "@components/modules/marketing/automation/form/steps/panel/whatsapp/MarketingAutomationFormPanelWhatsapp";
import EventBus from "@packages/event-bus";

export default {
  components: {
    MarketingAutomationFormPanelEmail,
    MarketingAutomationFormPanelEntry,
    MarketingAutomationFormPanelSms,
    MarketingAutomationFormPanelTimer,
    MarketingAutomationFormPanelWhatsapp,
  },

  props: {
    step: {
      type: Object,
    },
    type: {
      type: String,
      required: true,
    },
    showing: {
      type: Boolean,
      default: false,
    },
    automationId: {
      type: String,
    },
  },

  data() {
    return {
      form: {},
      isFilterOpened: false,
    };
  },

  computed: {
    isEmailType() {
      return this.type === "EMAIL";
    },
    isEntryType() {
      return this.type === "ENTRY";
    },
    isSmsType() {
      return this.type === "SMS";
    },
    isTimerType() {
      return this.type === "TIMER";
    },
    isWhatsappType() {
      return this.type === "WHATSAPP";
    },
    title() {
      return this.isEntryType
        ? this.$t("message.automation.message.flowInput")
        : this.isEmailType
        ? this.$t("message.automation.message.sendEmail")
        : this.isSmsType
        ? this.$t("message.automation.message.sendSms")
        : this.isTimerType
        ? this.$t("message.automation.message.wait")
        : "";
    },
  },

  methods: {
    setIsFilterOpened(isFilterOpened) {
      this.isFilterOpened = isFilterOpened;
    },
    emitSteps(steps) {
      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: this.$t("message.successMessages.message.automationSaved"),
      });

      this.$emit("submit", steps);
    },
    hidePanel() {
      this.$emit("hide");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

$border: 2px solid $grey-1;

.border-bottom {
  border-bottom: $border;
}

.panel-body > * {
  padding: 15px;

  .add-option {
    margin-bottom: 6px;
  }
}

.marketing-automation-form-panel {
  position: fixed;
  top: 50px;
  right: 15px;
  width: 270px;
  border: 1px solid $grey-1;
  border-radius: 25px;
  background-color: $white;
  box-shadow: $shadow-2;
  z-index: 2;

  .marketing-automation-form-panel-header {
    padding: 20px 0;

    .marketing-automation-form-panel-header-title {
      margin: 0;
    }
  }

  max-height: calc(100vh - 60px);

  &.marketing-automation-form-panel_hidden {
    display: none;
  }

  .close {
    background: white;
    cursor: pointer;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 5px;
    left: 5px;
    height: 30px;
    width: 30px;
    font-size: 28px;
    // box-shadow: 0 3px 6px rgba(#000000, 0.16);
    z-index: 1;
    border-radius: 50%;
  }

  &.marketing-automation-form-panel_opened {
    overflow: visible;
  }
}

::-webkit-scrollbar {
  width: 5px;
}
</style>
